import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
// import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class EditCurrency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        name: this.props.ItemList ? this.props.ItemList.name : null,
        iso4217Code: this.props.ItemList
          ? this.props.ItemList.iso4217Code
          : null,
        symbol: this.props.ItemList ? this.props.ItemList.symbol : null,
        subunit: this.props.ItemList ? this.props.ItemList.subunit : null,

        // isActive: this.props.ItemList ? this.props.ItemList.isActive : null,
      },
    };
    // this.handleChange = this.handleChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.submit = this.submit.bind(this);
    this.selectCurrency = this.selectCurrency.bind(this);
  }

  validate = () => {
    let isError = false;
    let regex = /[a-z]|[a-z]\s/i;

    const errmsg1 = "Enter a valid input";
    const errmsg2 = "This field cannot be empty";

    const errors = {
      nameError: "",
      iso4217CodeError: "",
      symbolError: "",
      subunitError: "",
    };

    if (!regex.test(this.state.value.name)) {
      isError = true;
      errors.nameError = errmsg1;
    }
    if (this.state.value.name == "") {
      isError = true;
      errors.nameError = errmsg2;
    }
    if (!regex.test(this.state.value.iso4217Code)) {
      isError = true;
      errors.iso4217CodeError = errmsg1;
    }
    if (this.state.value.iso4217Code == "") {
      isError = true;
      errors.iso4217CodeError = errmsg2;
    }
    if (!regex.test(this.state.value.symbol)) {
      isError = true;
      errors.symbolError = errmsg1;
    }
    if (this.state.value.symbol == "") {
      isError = true;
      errors.symbolError = errmsg2;
    }
    if (!regex.test(this.state.value.subunit)) {
      isError = true;
      errors.subunitError = errmsg1;
    }
    if (this.state.value.subunit == "") {
      isError = true;
      errors.subunitError = errmsg2;
    }

    this.setState({
      ...this.state,
      ...errors,
    });

    return isError;
  };

  submit() {
    let data = this.state.value;

    const err = this.validate();

    if (!err) {
      this.props.EditCurrency(this.state.value);

      this.props.closeEditModel();
      this.props.resetPage();
    }
  }

  onChange(event) {
    let field = event.target.name;
    let value = event.target.value;

    if (field == "name") {
      this.setState({
        value: { ...this.state.value, name: value },
      });
    } else if (field == "iso4217Code") {
      this.setState({
        value: { ...this.state.value, iso4217Code: value },
      });
    } else if (field == "symbol") {
      this.setState({
        value: { ...this.state.value, symbol: value },
      });
    } else if (field == "subunit") {
      this.setState({
        value: { ...this.state.value, subunit: value },
      });
    }
  }

  // handleChange(checked) {
  //   this.setState({ value: { ...this.state.value } });
  // }

  selectCurrency(event) {
    this.setState({
      value: { ...this.state.value, cntryId: event.target.value },
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        name: nextProps.ItemList && nextProps.ItemList.name,
        iso4217Code: nextProps.ItemList && nextProps.ItemList.iso4217Code,
        symbol: nextProps.ItemList && nextProps.ItemList.symbol,
        subunit: nextProps.ItemList && nextProps.ItemList.subunit,

        // isActive: nextProps.ItemList && nextProps.ItemList.isActive,
        id: nextProps.ItemList && nextProps.ItemList.id,
      },
    });
  }

  render() {
    return (
      <div>
        <Modal
          show={this.props.showEditModel}
          onHide={this.props.closeEditModel}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Currency</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Form>
                <Row>
                  <Col lg={6} md={12} sm={12} xs={12}>
                    <div>
                      <Form.Group controlId="iso4217Code">
                        <Form.Label> ISO 4217 Code </Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="iso4217Code"
                          onChange={this.onChange}
                          value={this.state.value.iso4217Code}
                        />
                        <div className="errStyle">
                          {this.state.iso4217CodeError}
                        </div>
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group controlId="name">
                        <Form.Label> Name</Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="name"
                          onChange={this.onChange}
                          value={this.state.value.name}
                        />
                        <div className="errStyle">{this.state.nameError}</div>
                      </Form.Group>
                    </div>
                  </Col>

                  <Col lg={6} md={12} sm={12} xs={12}>
                    <div>
                      <Form.Group controlId="symbol">
                        <Form.Label> Symbol </Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="symbol"
                          onChange={this.onChange}
                          value={this.state.value.symbol}
                        />
                        <div className="errStyle">{this.state.symbolError}</div>
                      </Form.Group>
                    </div>
                    <div>
                      <Form.Group controlId="subunit">
                        <Form.Label> Subunit </Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="subunit"
                          onChange={this.onChange}
                          value={this.state.value.subunit}
                        />
                        <div className="errStyle">
                          {this.state.subunitError}
                        </div>
                      </Form.Group>
                    </div>

                    {/* <div>
                        <label style={{ display: "flex", marginTop: "8px" }}>
                          <div style={{ marginRight: "30px" }}>
                            <span>Active</span>
                          </div>
                          <div style={{ marginTop: "-5px" }}>
                            <Switch
                              onChange={this.handleChange}
                              onColor="#20a8d8"
                              checked={this.state.value.isActive}
                            />
                          </div>
                        </label>
                      </div> */}
                    {/* </div> */}
                  </Col>
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditCurrency;
